class CollectionCarousel {
  constructor(el) {
    this.el = el;
    this.items = this.el.querySelectorAll('[data-collection-carousel-item]');
    this.count = this.items.length;
    this.arrowLeft = this.el.querySelector('[data-collection-carousel-arrow-left]');
    this.arrowRight = this.el.querySelector('[data-collection-carousel-arrow-right]');
    this.index = 0;


    if (this.count > 1 && this.arrowLeft && this.arrowRight) {
      this.arrowLeft.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.prev()
      })
      this.arrowRight.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.next()
      })
    }
  }

  prev() {
    if (this.index === 0) {
      this.index = this.count - 1;
    } else {
      this.index--;
    }
    this.setActiveItem();
  }

  next() {
    if (this.index === this.count - 1) {
      this.index = 0;
    } else {
      this.index++;
    }
    this.setActiveItem();
  }

  setActiveItem() {
    this.items.forEach((item) => {
      item.classList.remove('active');
    })
    this.items[this.index].classList.add('active');
  }
}

(function () {
  const items = document.querySelectorAll('[data-collection-carousel]');
  items.forEach((item) => {
    new CollectionCarousel(item);
  })
})()

